













import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormQuestion } from '@/interfaces/registration/FormQuestion';
import { QuestionModel } from '@/interfaces/registration/models/QuestionModel';
import { RegistrationData } from '@/interfaces/registration/RegistrationData';
import { namespace } from 'vuex-class';
const registration = namespace('registration');

@Component
export default class QuestionInputFileUpload extends Vue {
  @Prop({ default: () => { return {}; } }) readonly formQuestion!: FormQuestion;
  @Prop({ default: () => { return {}; } }) readonly value!: QuestionModel;

  @registration.State
  public registrationData!: RegistrationData;

  private existingFileUrl = '';

  get model (): string {
    return this.value.value as string;
  }

  set model (newValue: string) {
    this.$emit('input', { id: this.formQuestion.id, value: newValue });
  }

  get hasUrl (): boolean {
    if (typeof this.value.value === 'string') {
      this.$emit('input', { id: this.formQuestion.id, value: undefined });
      this.existingFileUrl = this.registrationData.communityPreferences?.storageUrl + 'forms/' + this.formQuestion.formID + '/' + this.value.value as string;
    }

    return this.existingFileUrl !== '';
  }
}
